import { Plan } from 'components/billing/common/types';

const starterPackageName = 'Starter';

export function isMinSpendStarterPlan(plan?: Plan | null): boolean {
  return (
    !!plan?.minimumCommittedSpendCents &&
    plan.package?.name === starterPackageName
  );
}

export function renderMinimumSpend(plan: Plan) {
  const sigFigs = plan.minimumCommittedSpendCents % 100 === 0 ? 0 : 2;

  if (plan.minimumCommittedSpendCents) {
    return `$${(plan.minimumCommittedSpendCents / 100).toFixed(
      sigFigs,
    )} monthly minimum spend`;
  }
}

export function isEndDateBeforeStartDate(
  endDate: string,
  startDate: string,
): boolean {
  const end = new Date(endDate);
  const start = new Date(startDate);
  return end < start;
}

export function isStartDateInFuture(startDate: string): boolean {
  const start = new Date(startDate);
  return start > new Date();
}
